import { Injectable } from '@angular/core';
import { DialogService } from '../../customs/_modal/dialog.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class HandleErrorsService {

  constructor(
    private dialogService: DialogService,
    private router: Router
  ) {}

  public catchError = ((error: { status: number, url?: string }): void => {
    const protectedEndpoints = ['/api/', '/ws-']; // Ajoute ici les chemins sécurisés

    switch (error.status) {
      case 401:
        // Vérifie si l'URL est protégée (évite de réagir à /login, /public etc.)
        const isProtected = protectedEndpoints.some(ep => error.url?.includes(ep));
        const isNotAlreadyOnLogin = !this.router.url.includes('authentication');

        if (isProtected && isNotAlreadyOnLogin) {
          this.dialogService.openDangerDialog('Votre session a expiré. Redirection en cours...');
          setTimeout(() => {
            sessionStorage.clear(); // Optionnel si tu veux vraiment forcer la déconnexion
            this.router.navigate(['/authentication']);
          }, 3000);
        }
        break;

      case 403:
        this.dialogService.openDangerDialog('Vous n\'avez pas les permissions nécessaires pour cette action.');
        break;

      case 400:
        this.dialogService.openDangerDialog('Certains champs sont invalides. Veuillez les vérifier.');
        break;

      case 500:
        this.dialogService.openDangerDialog('Une erreur est survenue. Veuillez réessayer plus tard.');
        break;

      default:
        this.dialogService.openDangerDialog('Une erreur inattendue est survenue. Veuillez réessayer.');
        break;
    }
  });
}
